module.exports = __webpack_public_path__ + "static/media/mensuration-tab.177b9c08.svg";